var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('TopNavBar',{attrs:{"msg":"編輯群組","show":true}}),_c('div',{staticClass:"content-container"},[_c('EditGroupFrom')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }